import { VerticalLayout } from "ds_legacy/materials/layouts";
import { padding } from "ds_legacy/materials/metrics";
import {
  DatePickerWithLabel,
  Footnote,
  FootnoteDescription,
  FootnoteLabel,
  GAP,
  Section,
  SectionRow,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";
import Translations from "translations/types";

const FOOTNOTE: Footnote = {
  description: (translations: Translations) =>
    translations.patientForms.transitionalCareForm.contactInformation
      .footnoteInsuranceNumber,
  label: (translations: Translations) =>
    translations.patientForms.transitionalCareForm.contactInformation
      .patientInsuranceNumber,
  superText: 1,
};

export const PatientContactSection = () => {
  const translations = useTranslations();
  return (
    <Section
      title={
        translations.patientForms.transitionalCareForm.contactInformation
          .titlePatient
      }
    >
      <SectionRow>
        <TextInputWithLabel
          elementName="patient_last_name"
          isBold
          isLarge
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .patientName
          }
        />
        <TextInputWithLabel
          elementName="patient_first_name"
          isBold
          isLarge
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .patientFirstName
          }
        />
        <DatePickerWithLabel
          elementName="patient_date_of_birth"
          isBold
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .patientBirthDate
          }
          shouldDisableFuture
        />
      </SectionRow>

      <SectionRow>
        <TextInputWithLabel
          elementName="patient_insurance_number"
          isBold
          isLarge
          label={<FootnoteLabel footnote={FOOTNOTE} />}
        />
        <TextInputWithLabel
          elementName="patient_location_street"
          isBold
          isLarge
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .patientStreet
          }
        />
        <TextInputWithLabel
          elementName="patient_location_house_number"
          isBold
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .patientStreetNumber
          }
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          elementName="patient_location_zipcode"
          isBold
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .patientZipCode
          }
        />
        <TextInputWithLabel
          elementName="patient_location_city"
          isBold
          isLarge
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .patientCity
          }
        />
      </SectionRow>
      <VerticalLayout
        style={{
          boxSizing: "border-box",
          padding: padding(GAP, 0, 0),
        }}
      >
        <FootnoteDescription footnote={FOOTNOTE} />
      </VerticalLayout>
    </Section>
  );
};
